import React, { useCallback, useState } from "react";
import wizard_css from "../../inspection.module.css";

export default function CheckFile({ check, setCheckValue, topLevel }) {
  const [pdf_placeholder, set_pdf_placeholder] = useState(false);
  const setFile = useCallback(
    (event) => {
      const elem = event.target;
      if (elem.files && elem.files[0]) {
        var fr = new FileReader();
        set_pdf_placeholder(elem.files[0].type.indexOf("image") !== 0);
        fr.onload = function (inner_event) {
          setCheckValue(inner_event.target.result, check.id, topLevel);
        };
        /* seems a bit clunky to ty to preview a pdf, so just use a placeholder pdf div. */
        fr.readAsDataURL(elem.files[0]);
      }
    },
    [check.id, setCheckValue, topLevel]
  );
  return (
    <div>
      <div>
        {check.critical && (
          <small className="bg-danger">
            This value puts equipment out of service!
          </small>
        )}
      </div>
      <label className={wizard_css["text"]}>
        {check.value && (
          <div className="thumbnail">
            {pdf_placeholder && <div className="thumb-upload">PDF</div>}
            {!pdf_placeholder && (
              <img className="thumb-upload" src={check.value} alt="" />
            )}
          </div>
        )}

        <span>{check.title}</span>
        <input
          readOnly={check.locked}
          type="file"
          onChange={(event) => setFile(event)}
          jf-properties="check.metadata.properties"
        />
      </label>
    </div>
  );
}
